import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Get main header height
 * Return the header current height calculated through a resizeObserver
 */
export function useHeaderHeight() {
  /**  */
  const headerHeight = ref(0)

  /** Main page header element */
  const headerElement = document.querySelector('.js-header-height')

  /** Observes header height */
  const headerHeightObserver = new ResizeObserver((entries) => {
    const entry = entries[0]
    headerHeight.value = entry.contentRect.height
  })

  /** Start to observe for header height */
  onMounted(() => {
    if (headerElement) {
      headerHeightObserver.observe(headerElement)
    }
  })

  /** Stop to observe for header height */
  onUnmounted(() => {
    headerHeightObserver.disconnect()
  })

  return { headerHeight }
}
